import { render } from "./RiskRewardRadar.vue?vue&type=template&id=4e03ca98&ts=true"
import script from "./RiskRewardRadar.vue?vue&type=script&lang=ts"
export * from "./RiskRewardRadar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__